import { Flow_0_0_2 } from '@flexus/core';

export const SIL_46: Flow_0_0_2 = {
	id: '46',
	name: 'invoice_query',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to respond'
		}
	},
	startNode: '',
	nodes: {}
};
